import { Form, Row, Col, Input, Button } from "antd";
import Feather from '@sysunite/react-feather'

export const BugfixRecordList = ({ active, rowIndex, quarterStartDate, quarterEndDate }) => {
  const colStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0px 5px' }
  return(
    <Form.List name={[rowIndex, 'records']}>
      {(fields, { add, remove }) => {
        return (
          <div key={`records-${rowIndex}`}>
            {
              fields.map((field, index) => {
                return(
                  <Form.Item
                    key={field.key}
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Row style={{ margin: "10px 0px" }} type="flex">
                      <Col style={{ flex: 1, ...colStyle }}>
                        old:
                      </Col>
                      <Col style={{ flex: 2, ...colStyle }}>
                        <Form.Item
                          noStyle
                          name={[field.name, 'oldSubject']}
                        >
                          <Input disabled={true}/>
                        </Form.Item>
                      </Col>
                      <Col style={{ flex: 2, ...colStyle }}>
                        <Form.Item
                          noStyle
                          name={[field.name, 'oldPredicate']}
                        >
                          <Input disabled={true}/>
                        </Form.Item>
                      </Col>
                      <Col style={{ flex: 2, ...colStyle }}>
                        <Form.Item
                          noStyle
                          name={[field.name, 'oldObject']}
                        >
                          <Input disabled={true}/>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={{ margin: "10px 0px" }} type="flex">
                      <Col style={{ flex: 1, ...colStyle }}>
                        new:
                      </Col>
                      <Col style={{ flex: 2, ...colStyle }}>
                        <Form.Item
                          noStyle
                          name={[field.name, 'newSubject']}
                        >
                          <Input disabled={true}/>
                        </Form.Item>
                      </Col>
                      <Col style={{ flex: 2, ...colStyle }}>
                        <Form.Item
                          noStyle
                          name={[field.name, 'newPredicate']}
                        >
                          <Input disabled={true}/>
                        </Form.Item>
                      </Col>
                      <Col style={{ flex: 2, ...colStyle }}>
                        <Form.Item
                          noStyle
                          name={[field.name, 'newObject']}
                        >
                          <Input disabled={true}/>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                )
              })
            }
          </div>
        )}
      }
    </Form.List>
  )
}

const first = (arr) => arr[0]
const idOrValue = (item) => {
  if (item === undefined || item === null) {
    return item;
  }
  if (item.id !== undefined) {
    return item.id();
  } else {
    return item.value;
  }
}

export const mapBugfixIntervention = (intv) => ({
  intervention: intv.value,
  name: first(intv.children?.name)?.value?.value,
  reason: first(intv.children?.reason)?.value?.value,
  docid: first(intv.children?.docid)?.value?.value,
  qname: intv.children?.qid?.map((n) => n?.value?.id()),
  records: intv.children?.record.map((record) => ({
    oldSubject: first(record.children?.oldSubject)?.value?.id(),
    newSubject: first(record.children?.newSubject)?.value?.id(),
    oldPredicate: first(record.children?.oldPredicate)?.value?.id(),
    newPredicate: first(record.children?.newPredicate)?.value?.id(),
    oldObject: idOrValue(first(record.children?.oldObject)?.value),
    newObject: idOrValue(first(record.children?.newObject)?.value),
  }))
})
